module.exports = __webpack_public_path__ + "img/User_management-B.a9a7a3e4.svg";